import React, { useMemo } from "react";
import { List, Typography, Divider } from "antd";
import { connect } from "dva";
import { getUrlParams, formatPrice } from "@/utils/utils";
import VehicleItem from "./VehicleItem";
import styles from "./VehiclesList.styles.less";

const { Text, Title } = Typography;

const VehiclesList = ({
  loading,
  configPerm,

  vehicles,
  highlightVin,
  priceExtractor,
  shipmentData,
  extra,
  subHeader,
  multiPrice,
  multiPriceTitles,
  itemExtra,
  descriptionColumn,
  pricesSpacing,
  compact,
  hideTitle,
  updatedQuotes,
  onQuoteUpdate,
  onNotesUpdate,
}) => {
  const { entityId } = getUrlParams(["vin", "entityId"]);

  const prices = useMemo(() => {
    if (typeof priceExtractor !== "function") {
      return {};
    }

    const _prices = {};

    (vehicles || []).forEach(item => {
      _prices[item.id] = priceExtractor(item) || 0;
    });

    return _prices;
  }, [priceExtractor]);

  const total = useMemo(() => {
    const keys = Object.keys(prices);

    if (multiPrice) {
      if (keys.length === 0) {
        return [];
      }

      const firstValue = new Array(prices[keys[0]].length).fill(0);

      return keys.reduce((prevValue, key) => {
        const newSum = [...prevValue];
        for (let i = 0; i < prevValue.length; i++) {
          const value = prices[key][i];
          newSum[i] += typeof value === "number" && !isNaN(value) ? value : 0;
        }

        return newSum;
      }, firstValue);
    }

    return keys.reduce((prevValue, key) => {
      return prevValue + (prices[key] || 0);
    }, 0);
  }, [prices, multiPrice, multiPriceTitles?.length]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        marginTop: hideTitle ? "0" : "16px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        {!hideTitle && <Title level={4}>Vehicles</Title>}

        <div>{extra}</div>
      </div>

      {subHeader}

      <Divider
        style={{
          margin: 0,
          borderTopWidth: "3px",
        }}
      />

      <List
        itemLayout="vertical"
        loading={loading}
        dataSource={vehicles}
        rowKey={vehicle => vehicle.id}
        extra={updatedQuotes}
        renderItem={item => (
          <VehicleItem
            item={item}
            updatedQuotes={updatedQuotes}
            compact={compact}
            highlightVin={highlightVin}
            prices={prices}
            shipmentData={shipmentData}
            entityId={entityId}
            multiPrice={multiPrice}
            multiPriceTitles={multiPriceTitles}
            itemExtra={itemExtra}
            descriptionColumn={descriptionColumn}
            pricesSpacing={pricesSpacing}
            configPerm={configPerm}
            onNotesUpdate={onNotesUpdate}
            onQuoteUpdate={newQuote => {
              if (typeof onQuoteUpdate === "function") {
                onQuoteUpdate(newQuote, item);
              }
            }}
          />
        )}
      />

      <Divider className={styles.totalPriceDivider} />

      <div className={styles.totalPriceWrapper}>
        <div style={{ display: "flex", flex: 1 }} />

        {multiPrice ? (
          <>
            <div className={styles.multiPriceSpacer} />
            {total.map((value, index) => (
              <div key={index} className={styles.multiPriceTotalWrapper}>
                <Text style={{ fontSize: "12px", textAlign: "center" }}>Total {multiPriceTitles[index]}</Text>
                <Text>{formatPrice(value)}</Text>
              </div>
            ))}
          </>
        ) : (
          <Text>Total: {formatPrice(total)}</Text>
        )}
      </div>
    </div>
  );
};

export default connect(({ configs }) => ({
  configPerm: configs.configPerm,
}))(VehiclesList);
